import React from "react";
import "./NormalTourViewMore.css";
import { useNavigate } from "react-router-dom";
import rishikesh from "../../assets/rishikesh.png";
import coorg from "../../assets/coorg.png";
import varanasi from "../../assets/varanasi.png";
import darjeeling from "../../assets/darjeeling.png";
import meghalaya from "../../assets/meghalaya.png";
import ranthambore from "../../assets/ranthambore.png";
import pondicherry from "../../assets/pondicherry.png";
import mysore from "../../assets/mysore.png";
import spiti from "../../assets/spiti.png";

const packages = [
  {
    img: rishikesh,
    tag: "Trending",
    name: "Rishikesh",
    info: "4 Days – River Rafting & Camping",
    link: "/tour-package-data",
  },
  {
    img: coorg,
    tag: "Nature",
    name: "Coorg",
    info: "5 Days – Coffee Trails Retreat",
    link: "/tour-package-data",
  },
  {
    img: varanasi,
    tag: "Spiritual",
    name: "Varanasi",
    info: "3 Days – Ganga Aarti Experience",
    link: "/tour-package-data",
  },
  {
    img: darjeeling,
    tag: "Hill Station",
    name: "Darjeeling",
    info: "6 Days – Tea Gardens & Toy Train",
    link: "/tour-package-data",
  },
  {
    img: meghalaya,
    tag: "Explorer",
    name: "Meghalaya",
    info: "7 Days – Waterfalls & Living Roots",
    link: "/tour-package-data",
  },
  {
    img: ranthambore,
    tag: "Wildlife",
    name: "Ranthambore",
    info: "3 Days – Tiger Safari Adventure",
    link: "/tour-package-data",
  },
  {
    img: pondicherry,
    tag: "Coastal",
    name: "Pondicherry",
    info: "4 Days – French Town Escape",
    link: "/tour-package-data",
  },
  {
    img: mysore,
    tag: "Heritage",
    name: "Mysore",
    info: "3 Days – Palace & Culture Tour",
    link: "/tour-package-data",
  },
  {
    img: spiti,
    tag: "Offbeat",
    name: "Spiti Valley",
    info: "8 Days – Himalayan Road Journey",
    link: "/tour-package-data",
  },
];

const NormalTourViewMore = () => {
  const navigate=useNavigate()
  return (
    <div className="packages-main">
      <div className="packages-grid">
        {packages.map((pkg, index) => (
          <div
            className="package-cards"
            key={index}
            onClick={() =>
              navigate(pkg.link, {
                state: { title: pkg.name },
              })
            }
          >
            <div className="package-img-wrapperr">
              <img src={pkg.img} alt={pkg.name} />
              <span className="package-tag">{pkg.tag}</span>
            </div>

            <div className="package-content">
              <h3>{pkg.name}</h3>
              <h2>{pkg.info}</h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NormalTourViewMore;
